import PropTypes from 'prop-types';
import { Row } from 'react-materialize';
import './ForbiddenPlate.css';

export default function ForbiddenPlateMarkup({ variant = 'default' }) {
  if (variant === 'pricelist') {
    return (
      <Row className="plate__wrapper">
        <h3>Хотите автоматизировать обработку прайсов ЛПУ?</h3>
        <h5>
          Напишите запрос на:{' '}
          <a href="mailto:yuri.golubnichy@mainsgroup.ru">
            yuri.golubnichy@mainsgroup.ru
          </a>
        </h5>
      </Row>
    );
  }

  return (
    <Row className="plate__wrapper">
      <h3>Доступ запрещен</h3>
      <h4>
        Код ошибки: <span>403</span>
      </h4>
      <h5>
        Для получения доступа напишите запрос на{' '}
        <a href="mailto:support@mainsgroup.ru">support@mainsgroup.ru</a>
      </h5>
    </Row>
  );
}

ForbiddenPlateMarkup.propTypes = {
  variant: PropTypes.oneOf(['default', 'pricelist']),
};
